<div id="registration-succes-component" class="gradientBackground">
  <div class="registration-succes-message-container">
    <h3 class="registrationTitle" i18n="confirmationPage: thank you title">Thank You!</h3>
    <p i18n="confirmationPage: success confirmation text">
      Your registration request has been submitted successfully.<br />
      You will receive a confirmation Email once your account data has been reviewed and your user has been commissioned.
    </p>
    <lib-taas-button (buttonPressedEvent)="goToHomepage()" buttonType="primary" btnId="homePageButton" buttonText="Back to the Utimaco Homepage"
      i18n-buttonText="confirmationPage: button label back to Utimaco Homepage"></lib-taas-button>
  </div>
</div>